import { render } from "./ModalKitsAndDomains.vue?vue&type=template&id=3bf1378c"
import script from "./ModalKitsAndDomains.vue?vue&type=script&lang=js"
export * from "./ModalKitsAndDomains.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/modals/ModalKitsAndDomains.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3bf1378c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3bf1378c', __exports__)) {
    api.reload('3bf1378c', __exports__)
  }
  
  module.hot.accept("./ModalKitsAndDomains.vue?vue&type=template&id=3bf1378c", () => {
    api.rerender('3bf1378c', render)
  })

}


export default __exports__